"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPatientName = createPatientName;
exports.formatName = formatName;
exports.createAddress = createAddress;
exports.createDateOfBirth = createDateOfBirth;
exports.createAge = createAge;
exports.formatAge = formatAge;
exports.computeAge = computeAge;
exports.createPhoneNumber = createPhoneNumber;
exports.createSocialSecurityNumber = createSocialSecurityNumber;
exports.createMaidenNameOfMother = createMaidenNameOfMother;
const events_1 = require("../../events");
const messages_1 = require("./messages");
const queries_1 = require("./queries");
function createPatientName(intl, { events }) {
    const event1 = (0, events_1.findLastEventByQuery)(events, queries_1.queries.title);
    const event2 = (0, events_1.findLastEventByQuery)(events, queries_1.queries.firstName);
    const event3 = (0, events_1.findLastEventByQuery)(events, queries_1.queries.lastName);
    if (event2 === undefined || event3 === undefined) {
        return "";
    }
    return formatName(intl, {
        title: event1?.value ?? "",
        firstName: event2.value,
        lastName: event3.value
    });
}
function formatName({ locale }, { title, firstName, lastName }) {
    let name = "";
    if (title !== "") {
        name += `${title} `;
    }
    if (locale === "hu") {
        name += `${lastName} ${firstName}`;
    }
    else {
        name += `${firstName} ${lastName}`;
    }
    return name;
}
function createAddress(_intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.address);
    if (event === undefined) {
        return undefined;
    }
    const { county, city } = event.value;
    return county ? `${county}, ${city}` : city;
}
function createDateOfBirth({ formatDate }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.dateOfBirth);
    if (event === undefined) {
        return undefined;
    }
    return formatDate(event.value, {
        year: "numeric",
        month: "numeric",
        day: "numeric"
    });
}
function createAge(intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.dateOfBirth);
    if (event === undefined) {
        return "";
    }
    return formatAge(intl, event.value);
}
function formatAge({ formatMessage }, dateOfBirth) {
    if (dateOfBirth === "") {
        return "";
    }
    const age = computeAge(dateOfBirth);
    return formatMessage(messages_1.genericMessages.yearsOfAge, { years: age });
}
function computeAge(dateOfBirth) {
    const d1 = new Date(dateOfBirth);
    d1.setUTCMilliseconds(0);
    d1.setUTCSeconds(0);
    d1.setUTCMinutes(0);
    d1.setUTCHours(0);
    const d2 = new Date();
    d2.setUTCMilliseconds(0);
    d2.setUTCSeconds(0);
    d2.setUTCMinutes(0);
    d2.setUTCHours(24);
    const d3 = new Date(d2.getTime() - d1.getTime());
    return Math.abs(d3.getUTCFullYear() - 1970);
}
function createPhoneNumber(_intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.phoneNumber);
    return event?.value[0] ?? undefined;
}
function createSocialSecurityNumber(_intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.socialSecurityNumber);
    return event?.value ?? undefined;
}
function createMaidenNameOfMother(_intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.maidenNameOfMother);
    return event?.value ?? undefined;
}
